import { Routes, Route } from "react-router-dom";
import { Companies } from "@/pages/Companies/Companies";

export const CompaniesRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<Companies />} />
        </Routes>
    );
};
